import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const AlkalinePosition = () => (
  <section data-testid="alkaline-position-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-center mb-12"
      >
        <div className="w-12 h-12 rounded-2xl bg-[#2C3E35]/10 flex items-center justify-center mx-auto mb-6">
          <ShieldCheck className="w-6 h-6 text-[#2C3E35]" strokeWidth={1.6} />
        </div>
        <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">
          Our Alkaline Position
        </p>
        <h2
          data-testid="alkaline-position-heading"
          className="font-display text-4xl md:text-5xl leading-tight tracking-tight font-medium text-[#1D1D1F]"
        >
          Alkalinity, stated responsibly.
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="space-y-5 text-base md:text-lg leading-relaxed text-[#1D1D1F]/75"
      >
        <p>
          Alkaline water is often associated globally with ideas such as enhanced hydration and
          general wellness. While research in some of these areas continues to emerge, Nyla
          deliberately does not make therapeutic or physiological claims.
        </p>
        <p>
          Instead, we position alkalinity as one important characteristic within the overall Nyla
          experience: an alkaline pH of 8–8.5, a balanced mineral profile, a clean and smooth
          taste, controlled purification and quality standards, sustainable atmospheric water
          generation, and premium glass-bottle presentation.
        </p>
        <p data-testid="alkaline-position-disclaimer" className="text-[#1D1D1F] font-medium">
          Our communication does not claim that alkaline water "alkalizes the body," treats
          acidity, detoxifies, improves immunity, or provides disease-related benefits. The
          8–8.5 pH is a product characteristic — not a medical or functional health proposition.
        </p>
        <p>
          We believe this measured approach lets us communicate what genuinely differentiates
          Nyla while remaining credible, responsible and transparent — never overstating the
          potential benefits associated with alkalinity.
        </p>
      </motion.div>
    </div>
  </section>
);
